/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ArrayDetectorType = {
    NoArray: 'NoArray',
    StarcheckMultiRange: 'StarcheckMultiRange',
    TwoDa: 'TwoDA',
    StarcheckSingleRange: 'StarcheckSingleRange',
    StarcheckMaxi1G: 'StarcheckMaxi1G',
    Od729: 'OD729',
    Od729Xdr: 'OD729XDR',
    StarcheckMaxiMr1G: 'StarcheckMaxiMR1G',
    Od1000: 'OD1000',
    Od1500: 'OD1500',
    Od1500Mr: 'OD1500MR',
    Od1500Xdr: 'OD1500XDR',
    Od1600: 'OD1600',
    Od1600Mr: 'OD1600MR',
    Od1600Xdr: 'OD1600XDR',
    StarcheckMaxi2G: 'StarcheckMaxi2G',
    StarcheckMaxiMr2G: 'StarcheckMaxiMR2G',
    TwoDetectorArraysSimultaneously: 'TwoDetectorArraysSimultaneously'
} as const;
export type ArrayDetectorType = typeof ArrayDetectorType[keyof typeof ArrayDetectorType];


export function ArrayDetectorTypeFromJSON(json: any): ArrayDetectorType {
    return ArrayDetectorTypeFromJSONTyped(json, false);
}

export function ArrayDetectorTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ArrayDetectorType {
    return json as ArrayDetectorType;
}

export function ArrayDetectorTypeToJSON(value?: ArrayDetectorType | null): any {
    return value as any;
}

/**
 * Check if a given object implements the ArrayDetectorType interface.
 */
 export function instanceOfArrayDetectorType(value: any): value is ArrayDetectorType {
    return Object.values(ArrayDetectorType).includes(value)
}

